import React from 'react';
import { object, string } from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { FormattedMessage } from '../../../util/reactIntl';
import { getCategories } from '../../../config/runtimeListingConfig';
import { getCategoryUrl } from '../../../util/categoryLandingHelpers';
import { stringify } from '../../../util/urlHelpers';

import css from './CategoryFacetSidebar.module.css';

/**
 * Category FACET sidebar for keyword-search results (browse redesign Phase 5,
 * README screen 4): the distribution of the current result set over the
 * category tree. Rows navigate to the category landing pages, keeping the search
 * words (as Reverb and eBay do). Counts render
 * only while the facet scan covered the whole result set (`exact`) — beyond
 * the cap the distribution still shows, unnumbered.
 */
const CategoryFacetSidebar = props => {
  const { className, facets, keywords } = props;
  const search = keywords ? `?${stringify({ keywords })}` : '';
  const categoryCounts = facets?.categoryCounts || {};
  const hasRefinements = Object.keys(categoryCounts).length > 0;

  const showCounts = !!facets?.exact;

  // Walk the tree, keep only branches present in the result set, two levels
  // deep (family + instrument) for scannability.
  const present = id => categoryCounts[id] > 0;
  const rows = [];
  getCategories().forEach(l1 => {
    if (!present(l1.id)) return;
    rows.push({ category: l1, depth: 0 });
    (l1.subcategories || []).forEach(l2 => {
      if (present(l2.id)) rows.push({ category: l2, depth: 1 });
    });
  });

  // Prototype keeps the card in the empty state with a quiet placeholder
  return (
    <nav className={classNames(css.root, className)}>
      <div className={css.label}>
        <FormattedMessage id="CategoryFacetSidebar.label" />
      </div>
      {hasRefinements ? (
        rows.map(({ category, depth }) => (
          <Link
            key={category.id}
            to={`${getCategoryUrl(category.id)}${search}`}
            className={classNames(css.row, { [css.rowChild]: depth > 0 })}
          >
            <span className={css.rowName}>{category.name}</span>
            {showCounts ? <span className={css.rowCount}>{categoryCounts[category.id]}</span> : null}
          </Link>
        ))
      ) : (
        <div className={css.empty}>
          <FormattedMessage id="CategoryFacetSidebar.empty" />
        </div>
      )}
    </nav>
  );
};

CategoryFacetSidebar.defaultProps = {
  className: null,
  facets: null,
  keywords: null,
};

CategoryFacetSidebar.propTypes = {
  className: string,
  facets: object,
  keywords: string,
};

export default CategoryFacetSidebar;
